module.exports = __webpack_public_path__ + "img/freeflow_spawner.43cfd158.png";